import styled from 'styled-components';
import { Checkbox } from 'antd';

export const StyledCheckbox = styled(Checkbox)<{ size: 'small' | 'large' }>`
  .ant-checkbox .ant-checkbox-inner,
  .ant-checkbox-input {
    transform: ${({ size }) => (size === 'small' ? 'none' : 'scale(1.5)')};
  }

  .ant-checkbox-label {
    white-space: nowrap;
    padding: 0px 12px !important;
  }

  .ant-checkbox .ant-checkbox-inner:after {
    ${({ size }) => (size === 'large' ? 'left: 20%' : '')}
  }

  .ant-checkbox .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  &.secondary-color {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${({ theme }) =>
        theme.palette.secondary.main} !important;
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }

    .ant-checkbox-checked:after {
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }

    .ant-checkbox:hover .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
      box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.secondary.main}33 !important;
    }

    .ant-checkbox-checked:hover .ant-checkbox-inner {
      background-color: ${({ theme }) =>
        theme.palette.secondary.main} !important;
      border-color: ${({ theme }) => theme.palette.secondary.main} !important;
      opacity: 0.8;
    }

    &:hover:not(.ant-checkbox-disabled) {
      .ant-checkbox-inner {
        border-color: ${({ theme }) => theme.palette.secondary.main} !important;
      }
    }

    .ant-checkbox-input:focus {
      outline: none;
    }

    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
      background-color: #f0f0f0 !important;
      border-color: #e0e0e0 !important;

      &:after {
        border-color: ${({ theme }) => theme.palette.secondary.main} !important;
      }
    }
  }
`;
